<template>
  <div class="receive-container">
    <img class="back-header" @click.stop="goBack" src="../../images/arrow.png" />
    <div
      v-for="(activityItem, activityIndex) in rewardInfo.activity"
      :key="activityItem.id"
      :class="['receive-content', { 'receive-content-2': activityIndex === 1 }]"
    >
      <block v-if="activityItem.activityName === '新人专享'">
        <img class="wanted-section-title-bg" src="../../images/wanted-card9.png" alt="ticket" />
        <img class="wanted-section-title-icon" src="../../images/wanted-card4.png" alt="ticket" />
      </block>
      <block v-if="activityItem.activityName === '官方补贴'">
        <img class="wanted-section-title-bg" src="../../images/wanted-card10.png" alt="ticket" />
        <img class="wanted-section-title-icon" src="../../images/wanted-card5.png" alt="ticket" />
      </block>
      <div class="receive-content-tabs">
        <div
          v-for="(taskItem, taskIndex) in activityItem.task"
          :key="taskItem.taskId"
          @click="handleTaskClick(activityIndex, taskIndex)"
          :class="['receive-content-tab-item', { active: taskIndex === activityItem.activeTab }]"
        >
          {{ taskItem.condition }}
        </div>
      </div>
      <div
        class="receive-content-desc"
        :class="{
          'receive-content-desc-collecting': !isTaskFinished(
            activityItem.task[activityItem.activeTab]
          )
        }"
      >
        <span>{{ activityItem.task[activityItem.activeTab].progressText }}</span>
        <span v-if="isWantCollecting(activityItem.task[activityItem.activeTab])">，</span>
        <span
          v-if="isWantCollecting(activityItem.task[activityItem.activeTab])"
          class="want-link"
          @click="goVoteWantIt"
        >
          去投「想要」>>
        </span>
      </div>
      <div
        v-for="(taskItem, taskIndex) in activityItem.task"
        :key="taskItem.taskId"
        v-show="taskIndex === activityItem.activeTab"
        class="receive-content-cards"
      >
        <div
          v-for="productItem in taskItem.product"
          :key="productItem.productId"
          @click="handleProductClick(productItem)"
          class="receive-content-card-item"
        >
          <img
            class="receive-content-card-item-icon"
            :src="productItem.imageUrls[0]"
            alt="ticket"
          />
          <span v-if="productItem.rewardStatus === 2" class="content-item-image-claim">
            <img src="../../images/wanted-card7.png" alt="ticket" />
          </span>
          <span v-if="productItem.rewardStatus === 3" class="content-item-image-claim">
            <img src="../../images/wanted-card8.png" alt="ticket" />
          </span>
          <div class="receive-content-card-item-title">{{ productItem.productName }}</div>
          <div class="receive-content-card-item-bottom">
            <div
              v-show="productItem.rewardStatus !== 4"
              class="receive-content-card-item-bottom-left"
            >
              <div v-if="productItem.discountPrice" class="new-price">
                ￥
                <span class="new-price-number">{{ productItem.discountPrice }}</span>
              </div>
              <div :class="['old-price', { active: !productItem.discountPrice }]">
                ￥{{ productItem.price }}
              </div>
            </div>
            <div
              v-show="productItem.rewardStatus === 4"
              class="receive-content-card-item-bottom-left"
            >
              <div class="new-price">
                ￥
                <span class="new-price-number">{{ productItem.price }}</span>
              </div>
            </div>
            <div
              class="receive-content-card-item-btn"
              :class="getButtonClass(productItem.rewardStatus, productItem.discountPrice)"
            >
              {{ getButtonText(productItem.rewardStatus, productItem.discountPrice) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wanted-btn" @click="goVoteWantIt">去投「想要」</div>
  </div>
</template>

<script setup>
  import { ref, defineEmits, onMounted } from 'vue'
  import { useRoute } from 'vue-router'
  import _fetch from '@/utils/fetch'
  import { goShopPages } from '../../util'
  const emit = defineEmits(['closeClaimRewards', 'goVoteWantIt'])
  const props = defineProps({
    taskId: {
      type: String,
      default: ''
    }
  })

  defineOptions({ name: 'AppReceive' })
  const goBack = () => {
    emit('closeClaimRewards')
  }

  const goVoteWantIt = () => {
    emit('goVoteWantIt')
  }

  const isWantCollecting = task => {
    return task.currentCount < task.totalCount
  }
  const isTaskFinished = task => {
    return ['ISSUED', 'UNCLAIM'].includes(task.status || '')
  }

  const route = useRoute()
  const rewardInfo = ref([])
  const initRewardList = async () => {
    const response = await _fetch('/aigc/api/activity/want-it/reward/list', {
      method: 'GET',
      params: {
        claimed: false
      }
    })
    const res = await response.json()
    console.log('res', res)
    if (res.code === 200) {
      res.data.activity.forEach(activity => {
        activity.activeTab = 0
      })
      rewardInfo.value = res.data
    }
  }

  const getButtonText = (status, discountPrice) => {
    if (status === 0) {
      return '待解锁'
    } else if (status === 1) {
      if (!discountPrice) {
        return '免费领取'
      } else {
        return '领取'
      }
    } else if (status === 2) {
      return '已领取'
    } else if (status === 3) {
      return '已失效'
    } else if (status === 4) {
      return '购买'
    }
  }
  const getButtonClass = (status, discountPrice) => {
    if (status === 0) {
      return 'waiting'
    } else if (status === 1) {
      return 'unclaim'
    } else if (status === 2) {
      return 'issued'
    } else if (status === 3) {
      return 'expired'
    } else if (status === 4) {
      return 'unclaim'
    }
  }

  const handleProductClick = productItem => {
    if (productItem.webUrl) {
      window.open(`${productItem.webUrl}?from=want_award_page`, '_blank')
    } else {
      goShopPages(`/detail/${productItem.productId}?from=want_award_page`, 'new')
    }
  }

  const handleTaskClick = (activityIndex, taskIndex) => {
    rewardInfo.value.activity[activityIndex].activeTab = taskIndex
  }

  onMounted(async () => {
    await initRewardList()
    const wantTaskId = Array.isArray(route.query.wantTaskId)
      ? route.query.wantTaskId[0]
      : route.query.wantTaskId
    const targetTaskId = props.taskId || wantTaskId
    if (targetTaskId && rewardInfo.value?.activity?.length) {
      rewardInfo.value.activity.forEach(activity => {
        const taskIndex = activity.task.findIndex(task => task.taskId === targetTaskId)
        activity.activeTab = taskIndex === -1 ? 0 : taskIndex
      })
    }
  })
</script>

<style lang="stylus" scoped>
  @import './index.styl';
</style>
